import { uploadService } from './../../../../shared/uploadService';
import { Component, OnInit } from '@angular/core';
import { EventsService } from '../../services/events-services';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import { EventsModel } from '../../models/events';
import { AddingWithAttatchementsBaseComponent } from '../../../../shared/Components/adding-with-attatchements-base/adding-with-attatchements-base.component';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import * as momentHijri from 'moment-hijri';
import { Router } from '@angular/router';
import { time } from 'console';

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
})
export class AddEventComponent extends AddingWithAttatchementsBaseComponent implements OnInit {
  model: EventsModel;
  isLoading: boolean = false;
  validPhoto: boolean = false;
  imgURL: any;
  file: any;
  formData: FormData = new FormData();
  message: string;
  imagePath: any;
  attachments: FormData = new FormData();
  isEdit = false;
  uploadThumbnail = false;
  invalidTime: boolean = false;
  isSubmited: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public diagRef: NbDialogRef<AddEventComponent>,
    public service: EventsService,
    public toast: NbToastrService,
    private uploadService: uploadService,
    private route : Router
  ) {
    super(service, null);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    }
    if (!this.isEdit) {
      this.model = {} as EventsModel;
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.uploadThumbnail = true;
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    } else {
      this.validPhoto = true;
    }
  // this.model.paymentMethods =[''];
  }
  // addPaymentMethod() {
  //   this.model.paymentMethods.push(''); // أضف عنصر جديد فاضي
  // }

  // removePaymentMethod(index: number) {
  //   if (this.model.paymentMethods.length > 1) {
  //     this.model.paymentMethods.splice(index, 1);
  //   }
  // }

  // // للحصول على القيم المُختارة فقط
  // getSelectedPaymentMethods(): string[] {
  //   return this.model.paymentMethods.filter(method => method !== '');
  // }

  removePhoot() {
    this.uploadThumbnail = true;
     this.validPhoto = false;
  }

  preview(files) {
    if (files.length === 0) return;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
    this.file = files;

    this.validPhoto = true;
  }

  save(form) {
    this.isLoading = true;
    if (!this.model.dateTime) {
      this.model.dateTime = momentHijri(new Date());
    }

    const img$ = this.uploadService.uploadImage(this.formData);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([img$, attachments$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          return of(null);
        }),

        switchMap(([img, attachments]) => {
          // Update the model with the uploaded image and attachments
          this.model.thumbnail = {
            fileName: img.fileName,
            originalFileName: img.originalFileName,
          } as FileVm;
          this.model.attachements = attachments;

          // .res.map((ele:FileVm) => { return {
          //   originalFileName:ele ,
          //   fileName :ele
          // }});

          // Return the observable that saves the entity
          return this.saveEntity(this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم إضافة فاعلية جديدة بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.isLoading = false;

          console.log(err);
          this.diagRef.close('true');
          this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
        },
      });

    //upload attachments michael
    //  this.uploadService.uploadMultipleFiles()
    //  .pipe(
    //  )

    // //  .subscribe({
    // //    next: (res) => {

    // //     console.log(res);
    // //  }
    // // })
  }

  saveEntity(model): Observable<any> {
    // return this.service.saveEvent(model)
    return this.service.post(model);
  }

  close() {
    this.diagRef.close();
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  updateEvent() {
    this.isLoading = true;
    let hasNewFile = false;
    this.formData.forEach((_) => {
      hasNewFile = true;
    });
    const img$ = hasNewFile
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(this.model.thumbnail);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([img$, attachments$])
      .pipe(
        switchMap(([img, attachments]) => {
          // Update the model with the uploaded image and attachments
          this.model.thumbnail =
            img.id != 0
              ? img
              : ({
                  fileName: img.fileName,
                  originalFileName: img.originalFileName,
                } as FileVm);

          console.log('attachments', attachments);

          this.model.attachements = attachments;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل الفاعلية بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل الفاعلية', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }
  formatTime(time: string): string {
    if (time == undefined) {
      return;
    }

    if (!time) return '';

    const [hours, minutes] = time.split(':').map(Number); // Split the time string and convert to numbers
    const date = new Date(); // Create a new Date object for today
    date.setHours(hours, minutes, 0, 0);
    return `${hours}:${minutes}`;
  }
  setDate(event) {
    this.model.dateTime = event;
  }
  isTimeGreater(): boolean {
    const [hour1, minute1] = this.model.to.split(':').map(Number);
    const [hour2, minute2] = this.model.from.split(':').map(Number);

    if (hour1 > hour2) {
      this.invalidTime = false;
      return;
    } else if (hour1 === hour2) {
      this.invalidTime = minute1 > minute2 ? false : true;
      return;
    } else {
      this.invalidTime = true;
      return;
    }
  }
}
